import { Box, TextField, Button, Typography } from "@mui/material";
import React from "react";

interface Props {
  feedback: string;
  setFeedback: (val: string) => void;
  displayingForAdmin?: boolean;
}

const FeedbackBox: React.FC<Props> = ({ feedback, setFeedback, displayingForAdmin = false }) => {
  return (
    <Box
      sx={{
        p: 2,
        border: "1px solid #ddd",
        borderRadius: 2,
        width: '20vw',
        height: '20vw',
        display: 'flex',
        flexDirection: 'column',
        gap: '1vw',
        mt: '1vw'
      }}
    >
      <Typography variant="subtitle1">
        Feedback on how we can improve
      </Typography>
      <textarea
        placeholder="Add feedback"
        disabled={displayingForAdmin}
        value={!displayingForAdmin ? feedback : ""}
        onChange={
          (e) => {
            if (!displayingForAdmin) {
              setFeedback(e.target.value)
            }
          }
        }
        style={{
          width: '100%',
          height: '14vw',
          resize: 'none',
          padding: '0.5vw',
          fontSize: '0.9vw',
          borderRadius: '4px',
          border: '1px solid #ccc',
          fontFamily: 'inherit',
          cursor: displayingForAdmin ? 'not-allowed' : 'text',
        }}
      />
      {/* <Button
        variant="outlined"
        fullWidth
        disabled
        sx={{
          mt: 2,
          cursor: 'not-allowed',
        }}
      >
        Submit Feedback
      </Button> */}

    </Box>
  );
};

export default FeedbackBox;
